import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { postGalleryPhotos, deleteGalleryPhotos } from '../../services/getAdminApi';
import { getGalleryImages } from '../../services/getAllApi';
import { IconButton, Button, TextField, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { Delete } from '@mui/icons-material';
import '../../styles/AddGalleryPhotos.css'; // Add your custom CSS here

const AddGalleryPhotos = () => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [initalText, setInitialText] = useState("Loading...")
  const [fileName, setFileName] = useState({
    image_path: ''
  });
  const [formData, setFormData] = useState({
    image_type: 'Certificates', // Default to Certificates type
    image_path: null, // Image path will be a file object
  });
  const [activeTab, setActiveTab] = useState('Certificates'); 

  useEffect(() => {
    fetchGalleryImages('Certificates'); 
  }, []);

  const fetchGalleryImages = async (type) => {
    try {
      const response = await getGalleryImages(type);
    
       if(response.status===200){
      setGalleryImages(Array.isArray(response.data.images) ? response.data.images : []);
       }
       else{
        setGalleryImages([])
        setInitialText("No Images for this section")
        
       }
      
    } catch (error) {
      Swal.fire('Error', 'Failed to fetch images', 'error');
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    fetchGalleryImages(tab); // Fetch images based on the selected tab
  };

  const handleDelete = async (id) => {
    const confirmDelete = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this image?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
    });

    if (confirmDelete.isConfirmed) {
      try {
        await deleteGalleryPhotos(id);
        Swal.fire('Success', 'Image deleted successfully', 'success');
        fetchGalleryImages(activeTab); // Fetch images based on the active tab
      } catch (error) {
        Swal.fire('Error', 'Failed to delete image', 'error');
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      setFormData({
        ...formData,
        [name]: files[0], 
      });
      setFileName({
        ...fileName,
        [name]: files[0].name,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSave = async () => {
    if (!formData.image_path || !formData.image_type) {
      Swal.fire('Validation Error', 'Please fill all required fields', 'error');
      return;
    }
    
    try {
      await postGalleryPhotos(formData).then((res) => {
        console.log("Data: ",formData, "Res: ", res)
        if (res.status === 201) {
          Swal.fire('Success', 'Image added successfully', 'success');
          fetchGalleryImages(activeTab)
        }
      });
      setFormData({
        image_path: null,
        image_type: activeTab 
      });
      setFileName({
        image_path: '',
      });
      document.getElementById("image_path").value = "";
    
      fetchGalleryImages(activeTab); 
    } catch (error) {
      console.log(error)
      Swal.fire('Error', 'Failed to save image', 'error');
    }
  };

  return (
    <div>
      
      {/* Tabs for selecting image types */}
      <div className="tabs-container">
        {['Certificates', 'RecruiterCompanies', 'GalleryPhoto'].map((tab) => (
          <button
            key={tab}
            className={`tab-button ${activeTab === tab ? 'active' : ''}`}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="dashboard-heading-div">
        <p>Manage {activeTab} Photos</p>
      </div>


      <div className='editing-container'>
        <div>
          <h2 className='editing-container-heading'> Add Images Here</h2>

          <div className="editing-container-form">
            <div className='editing-container-input-div'>
              <FormControl  style={{display: 'flex', flexDirection:'row', alignItems:'center'}}>
                <label>Image Type:</label>
                <Select
                  name="image_type"
                  value={formData.image_type}
                  onChange={handleInputChange}
                  required
                >
                  {['Certificates', 'RecruiterCompanies', 'GalleryPhoto'].map((type) => (
                    <MenuItem key={type} value={type}>{type}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <div className='editing-container-input-div'>
              <label>Add Image:</label>
              <label htmlFor="image_path" className="file-upload-btn">
                <i className='bx bx-cloud-upload'></i> {fileName.image_path || ' Choose File'}
              </label>
              <input
                className="file-upload"
                id="image_path"
                type="file"
                name="image_path"
               accept="image/*,image/webp"
                onChange={handleInputChange}
              />
            </div>
          </div>
          <Button variant="contained" color="primary" onClick={handleSave}>
            SAVE <i className='bx bx-send'></i>
          </Button>
        </div>
      </div>

      <div className="gallery-container">
        {galleryImages && galleryImages.length > 0 ? (
          galleryImages.map((image) => (
            <div key={image.id} className="gallery-card">
              <img
                src={`${"https://console.fbsedu.in/storage/app/"}/${image.image_path}`}
                alt="Gallery"
                className="gallery-image"
              />
              <IconButton
                className="delete-button"
                color="secondary"
                onClick={() => handleDelete(image.id)}
              >
                <Delete />
              </IconButton>
            </div>
          ))
        ) : (
          <p>{initalText}</p>
        )}
      </div>
    </div>
  );
};

export default AddGalleryPhotos;
